@import '@fontsource-variable/familjen-grotesk';
@import '@fontsource-variable/inter';
@import './tailwind.css';
@import './kendo.scss';

/* Strip <p> wrappers that ProseMirror (Kendo Editor) inserts inside <li>.
   Scoped to #root so it doesn't affect host-page list styles outside the app. */
#root li > p {
  display: inline;
  margin: 0;
  padding: 0;
}

/* Hint that a Grid column is sortable. Kendo always wraps headers in
   .k-link, tags non-sortable ones with !k-cursor-default, and adds
   .k-sort-icon while a column is actively sorted. We show Kendo's own
   arrows-top-bottom glyph on the rest so the affordance is visible up-front. */
.k-grid:not(.k-treelist)
  .k-grid-header
  .k-link:not(.\!k-cursor-default):not(:has(.k-sort-icon))::after {
  content: '';
  display: inline-block;
  width: 0.875rem;
  height: 0.875rem;
  margin-left: 0.25rem;
  vertical-align: text-bottom;
  opacity: 0.35;
  background-color: currentColor;
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath d='m240 512 80-128h-64V128h64L240 0l-80 128h64v256h-64z'/%3E%3C/svg%3E");
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath d='m240 512 80-128h-64V128h64L240 0l-80 128h64v256h-64z'/%3E%3C/svg%3E");
  mask-size: contain;
  -webkit-mask-size: contain;
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
}
